import { render, staticRenderFns } from "./securityGuide.vue?vue&type=template&id=8c526552&scoped=true"
import script from "./securityGuide.vue?vue&type=script&lang=js"
export * from "./securityGuide.vue?vue&type=script&lang=js"
import style0 from "./securityGuide.vue?vue&type=style&index=0&id=8c526552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c526552",
  null
  
)

export default component.exports